import { widgetStore } from '../store';
import { useSelectedFieldStore } from './useSelectedFieldStore';

export type UseWidgetSponsorsArg = {
  widgetId: string;
};

export function useWidgetSponsors({ widgetId }: UseWidgetSponsorsArg) {
  const widgetSponsors = useSelectedFieldStore(
    widgetStore,
    () => widgetStore.get()[widgetId]?.widgetPayload?.sponsors
  );
  return widgetSponsors;
}
